/* globals $ */

'use strict';

const EventMailForm = {
    selector: '.js-event-mail-form',
    emailRegex: /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/
};

EventMailForm.validateEmail = (email) => {
    return EventMailForm.emailRegex.test(email);
};

EventMailForm.getRedirecturl = $form => $form.find('input[name="eventMailRedirectUrl"]').val();

EventMailForm.init = () => {
    EventMailForm.onSubmit();
    EventMailForm.checkCookie();
};

EventMailForm.checkCookie = () => {
    const $form = $(EventMailForm.selector);
    const hasCookieAttr = $form.attr('data-has-cookie');
    if (hasCookieAttr && hasCookieAttr === 'true') {
        window.location = EventMailForm.getRedirecturl($form);
    }
};

EventMailForm.onSubmit = () => {
    $(document).on('submit', `form${EventMailForm.selector}`, e => {
        const $form = $(e.target).closest(EventMailForm.selector);
        const $formControlFeedback = $form.find('.form-control-feedback');
        $formControlFeedback.empty();
        $formControlFeedback.parents('.form-group').removeClass('has-danger');
        e.preventDefault();
        $.spinner().start();
        const formData = $form.serializeArray();
        $form
            .find('input[type=checkbox]')
            .each((index, el) => {
                const checkbox = formData.find(field => field.name === $(el).attr('name'));
                if (checkbox) {
                    checkbox.value = $(el).prop('checked');
                }
            });
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $.param(formData),
            success: data => {
                if (data.success && data.redirectUrl) {
                    window.location = EventMailForm.getRedirecturl($form);
                } else {
                    $formControlFeedback.text(data.errorMessage);
                    $formControlFeedback.parents('.form-group').addClass('has-danger');
                }
            },
            complete: () => {
                $.spinner().stop();
            }
        });
    });
};

module.exports = EventMailForm;
